<mat-card
    class="daxa-card recent-orders-card border-radius bg-white border-none d-block p-3"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <form class="search-box position-relative">
                <i class="material-symbols-outlined"> search </i>
                <input type="text" class="input-search d-block w-100 border-0 outline-0 rounded-pill"
                       placeholder="Chercher un type d'analyse..." (keyup)="applyFilter($event)" #input>
            </form>
        </mat-card-title>
        <mat-card-subtitle>
            <div class="btn-group">
                <button class="btn btn-outline-primary btn-sm rounded-start-pill" (click)="openModal(content)">
                    <i class="fa-solid fa-plus px-2"></i> Nouveau
                </button>
                <button class="btn btn-outline-primary btn-sm rounded-end-pill" [matMenuTriggerFor]="menu"
                    aria-haspopup="true" aria-expanded="false" id="dropdownMenuClickableInside">
                    <i class="fa-solid fa-sliders px-2"></i>
                </button>
            </div>
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div class="recent-orders-table">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort>
                    <!--  
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> ID</th>
                        <td mat-cell *matCellDef="let element"> {{ element.id }}</td>
                    </ng-container>
                -->
                    <ng-container matColumnDef="codeAT">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Code AT</th>
                        <td mat-cell *matCellDef="let element"> {{ element.codeAT }}</td>
                    </ng-container> 
                    <ng-container matColumnDef="methodesIds">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Méthodes </th>
                        <td mat-cell *matCellDef="let element">
                            {{ getMethodNames(element.methodes) }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="technique">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Technique </th>
                        <td mat-cell *matCellDef="let element"> {{ element.technique }}</td>
                    </ng-container> 
                      <ng-container matColumnDef="unite">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Unité</th>
                        <td mat-cell *matCellDef="let element"> {{ element.unite }}</td>
                    </ng-container> 

                    <ng-container matColumnDef="departmentName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Département </th>
                        <td mat-cell *matCellDef="let element"> {{ element.departmentName }}</td>
                    </ng-container>
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef> Nom</th>
                        <td mat-cell *matCellDef="let element"> {{ element.name }}</td>
                    </ng-container>
                    
                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef> Description</th>
                        <td mat-cell *matCellDef="let element"> {{ element.description }}</td>
                    </ng-container>
                    
                    <ng-container matColumnDef="prix">
                        <th mat-header-cell *matHeaderCellDef> Prix</th>
                        <td mat-cell *matCellDef="let element"> {{ element.prix }}</td>
                    </ng-container>
                    
                    <ng-container matColumnDef="meq">
                        <th mat-header-cell *matHeaderCellDef> MEQ</th>
                        <td mat-cell *matCellDef="let element"> {{ element.meq }}</td>
                    </ng-container>
                    
                    <ng-container matColumnDef="version">
                        <th mat-header-cell *matHeaderCellDef> Version</th>
                        <td mat-cell *matCellDef="let element"> {{ element.version }}</td>
                    </ng-container>
                    
                    <ng-container matColumnDef="dureeAna">
                        <th mat-header-cell *matHeaderCellDef> Durée Analyse</th>
                        <td mat-cell *matCellDef="let element"> {{ element.dureeAna }}</td>
                    </ng-container>
                    
                    <ng-container matColumnDef="dureeEnvoi">
                        <th mat-header-cell *matHeaderCellDef> Durée Envoi</th>
                        <td mat-cell *matCellDef="let element"> {{ element.dureeEnvoi }}</td>
                    </ng-container>
                    
                    <!--<ng-container matColumnDef="matriceId">
                        <th mat-header-cell *matHeaderCellDef> Matrice</th>
                        <td mat-cell *matCellDef="let element">{{ getMatriceName(element.matriceId)}}</td>
                    </ng-container>-->
                    
                    <ng-container matColumnDef="parameterIds">
                        <th mat-header-cell *matHeaderCellDef> Paramètres</th>
                        <td mat-cell *matCellDef="let element">
                            {{ getParameterName(element.parameters) }}
                        </td>                    
                    </ng-container>
                    
                   <ng-container matColumnDef="creationDate">
                        <th mat-header-cell *matHeaderCellDef> Date de création</th>
                        <td mat-cell *matCellDef="let element"> {{ element.creationDate | date: 'short' }}</td>
                    </ng-container>
                    
                   <!-- <ng-container matColumnDef="updateDate">
                        <th mat-header-cell *matHeaderCellDef> Date de mise à jour</th>
                        <td mat-cell *matCellDef="let element"> {{ element.updateDate | date: 'short' }}</td>
                    </ng-container>
                -->
                    <ng-container matColumnDef="createdBy">
                        <th mat-header-cell *matHeaderCellDef> Créé par</th>
                        <td mat-cell *matCellDef="let element"> {{ element.createdBy?.username || 'N/A' }}</td>
                    </ng-container>
                
                    
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Action</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-info text-center">
                                <button mat-button (click)="openViewModel(element)">
                                    <i class="material-symbols-outlined">visibility</i>
                                </button>
                                <button mat-button (click)="editTypeAnalyse(element)">
                                    <i class="material-symbols-outlined text-primary">brush</i>
                                </button>
                                <button mat-button (click)="confirmDelete(element)">
                                    <i class="material-symbols-outlined text-danger">delete</i>
                                </button>
                            </div>
                        </td>
                    </ng-container>
                    
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                <div *ngIf="loadingTable">
            <div *ngFor="let i of [].constructor(6)" class="skeleton-row">
                <span class="skeleton-cell"></span>
            </div>
          </div>
          </div>
          <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
            </div>
    </mat-card-content>
</mat-card>



<ng-template #content let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">Créer un Type d'Analyse</h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="form" (ngSubmit)="saveTypeAnalyse()">
                <div class="row">
                    
                    <!-- Code AT -->
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                            <mat-label>Code AT</mat-label>
                            <input matInput formControlName="codeAT" required>
                            <mat-error *ngIf="form.get('codeAT')?.hasError('required')">Code requis</mat-error>
                        </mat-form-field>
                    </div>
                    
                    <!-- Nom -->
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                            <mat-label>Nom</mat-label>
                            <input matInput formControlName="name">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                        <mat-label>Départements</mat-label>
                        <mat-select id="departments" formControlName="departmentId" multiple>
                            <mat-option *ngFor="let dep of departments" [value]="dep.id">
                            {{ dep.name }}
                        </mat-option>
                        </mat-select>            
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                        <mat-label>Méthodes</mat-label>
                        <mat-select formControlName="methodesIds" multiple>
                            <mat-option *ngFor="let met of methodes" [value]="met.id">
                                {{ met.code }}
                            </mat-option>
                        </mat-select>            
                        </mat-form-field>
                    </div> 
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                            <mat-label>Unité</mat-label>
                            <input matInput formControlName="unite">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                            <mat-label>Technique</mat-label>
                            <input matInput formControlName="technique">
                        </mat-form-field>
                    </div>
                    <!-- Prix -->
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                            <mat-label>Prix</mat-label>
                            <input matInput type="number" formControlName="prix">
                        </mat-form-field>
                    </div>
                    
                    <!-- Unité de mesure (Meq) -->
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                            <mat-label>Unité de mesure (Meq)</mat-label>
                            <input matInput formControlName="meq">
                        </mat-form-field>
                    </div>
                    
                    <!-- Version -->
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                            <mat-label>Version</mat-label>
                            <input matInput formControlName="version">
                        </mat-form-field>
                    </div>
                    
                    <!-- Durée d'analyse -->
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                            <mat-label>Durée d'analyse</mat-label>
                            <input matInput formControlName="dureeAna">
                        </mat-form-field>
                    </div>
                    
                    <!-- Durée d'envoi -->
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                            <mat-label>Durée d'envoi</mat-label>
                            <input matInput formControlName="dureeEnvoi">
                        </mat-form-field>
                    </div>
                    
                    <!-- Matrice 
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                            <mat-label>Matrice</mat-label>
                            <mat-select formControlName="matriceId">
                                <mat-option *ngFor="let matrice of matrices" [value]="matrice.id">
                                    {{ matrice.nom }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>-->

                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="full-width mb-3" appearance="fill">
                            <mat-label>Paramètres</mat-label>

                            <mat-select formControlName="parameterIds" multiple panelClass="custom-select-panel">

                            <!-- Option "Tout sélectionner" stylée -->
                        <mat-option
                        (click)="$event.stopPropagation(); toggleAllSelection()"
                        [class.mat-selected]="isAllSelected()"
                        class="select-all-option"
                        >
                        {{ isAllSelected() ? 'Tout désélectionner' : 'Tout sélectionner' }}
                        </mat-option>



                            <!-- Options individuelles avec spacing -->
                            <mat-option *ngFor="let param of parameters" [value]="param.id" class="param-option">
                                <span>{{ param.pesticide?.pesticideResidueName || param.codeParameter }}</span>
                            </mat-option>

                            </mat-select>
                        </mat-form-field>
                    </div>


                    <div class="col-sm-12">
                        <mat-form-field class="mb-3">
                            <mat-label>Description</mat-label>
                            <textarea matInput formControlName="description"></textarea>
                        </mat-form-field>
                    </div>
                    
                    <!-- Bouton d'enregistrement -->
                    <div class="col-sm-12 text-right mt-3">
                        <button type="submit" class="btn btn-outline-success">Enregistrer</button>
                    </div>
                    
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>



<!-- Modal template for infos -->
<ng-template #viewModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <h5 class="fw-bold mx-3">
            Détails du Type d'Analyse
        </h5>
        <div class="row m-3">
            <div class="col-sm-6 col-lg-4 border-top border-0 p-3">
                <div class="fw-bold">Code Type d'Analyse :</div>
                <p>{{ form.get('codeAT')?.value }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Nom :</div>
                <p>{{ form.get('name')?.value }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Description :</div>
                <p>{{ form.get('description')?.value }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Prix :</div>
                <p>{{ form.get('prix')?.value }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">MEQ :</div>
                <p>{{ form.get('meq')?.value }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top border-0 p-3">
                <div class="fw-bold">Unité :</div>
                <p>{{ form.get('unite')?.value }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top border-0 p-3">
                <div class="fw-bold">Technique :</div>
                <p>{{ form.get('technique')?.value }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Version :</div>
                <p>{{ form.get('version')?.value }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Durée d'Analyse :</div>
                <p>{{ form.get('dureeAna')?.value }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Durée d'Envoi :</div>
                <p>{{ form.get('dureeEnvoi')?.value }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Méthodes associées :</div>

                <ng-container *ngIf="selectedTypeAnalyse?.methodes?.length > 0; else noMethod">
                    <p *ngFor="let m of selectedTypeAnalyse.methodes" class="mb-1">
                        {{ m.name }} <span class="text-muted">({{ m.code }})</span>
                    </p>
                </ng-container>

                <ng-template #noMethod>
                    <p class="text-muted">Aucune méthode associée</p>
                </ng-template>
            </div>



            <!--
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Matrice associée :</div>
                <p>{{ getMatriceName(form.get('matriceId')?.value) }}</p>
            </div>-->
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Paramètres associés :</div>
                <p *ngIf="form.get('parameterIds')?.value?.length > 0; else noParams">
                    {{ getParameterName(form.get('parameterIds')?.value || []) }}
                </p>
                <ng-template #noParams>
                    <p>Aucun paramètre sélectionné</p>
                </ng-template>
            </div>        
        </div>
    </mat-card>
</ng-template>

<!--Modal template for editing-->
<ng-template #editModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">Modifier Type d'Analyse</h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="form" (ngSubmit)="saveUpdatedTypeAnalyse()">
                <div class="row">
                    
                    <!-- Code AT -->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Code AT</mat-label>
                            <input matInput formControlName="codeAT" required>
                            <mat-error *ngIf="form.get('codeAT')?.hasError('required')">Code requis</mat-error>
                        </mat-form-field>
                    </div>

                    <!-- Nom -->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Nom</mat-label>
                            <input matInput formControlName="name" required>
                            <mat-error *ngIf="form.get('name')?.hasError('required')">Nom requis</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                        <mat-label>Département</mat-label>
                        <mat-select formControlName="departmentId" required>
                            <mat-option *ngFor="let dept of departments" [value]="dept.id">
                                {{ dept.name }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get('departmentId')?.hasError('required')">
                            Département requis
                        </mat-error>
                        </mat-form-field>
                    </div>
                    <!-- Description -->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Description</mat-label>
                            <textarea matInput formControlName="description"></textarea>
                        </mat-form-field>
                    </div>

                    <!-- Prix -->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Prix</mat-label>
                            <input matInput type="number" formControlName="prix">
                        </mat-form-field>
                    </div>

                    <!-- MEQ -->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>MEQ</mat-label>
                            <input matInput formControlName="meq">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Unité</mat-label>
                            <input matInput formControlName="unite" >
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Technique</mat-label>
                            <input matInput formControlName="technique">
                        </mat-form-field>
                    </div>
                    <!-- Version -->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Version</mat-label>
                            <input matInput formControlName="version">
                        </mat-form-field>
                    </div>

                    <!-- Durée Analyse -->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Durée Analyse (jours)</mat-label>
                            <input matInput  formControlName="dureeAna">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Méthodes</mat-label>
                            <mat-select formControlName="methodesIds" multiple>
                                <mat-option *ngFor="let met of methodes" [value]="met.id">
                                    {{ met.code }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <!-- Durée Envoi -->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Durée Envoi (jours)</mat-label>
                            <input matInput formControlName="dureeEnvoi">
                        </mat-form-field>
                    </div>

                    <!-- Matrice ID (Sélection) 
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field>
                            <mat-label>Choisir une matrice</mat-label>
                            <mat-select formControlName="matriceId">
                                <mat-option *ngFor="let matrice of matrices" [value]="matrice.id">
                                    {{ matrice.nom }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        
                    </div>-->

                    <!-- Paramètres Associés (Sélection Multiple) -->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Paramètres Associés</mat-label>
                            <mat-select formControlName="parameterIds" multiple>
                                <mat-option *ngFor="let param of parameters" [value]="param.id">
                                    {{ param.pesticide?.pesticideResidueName || param.codeParameter }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <!-- Bouton Enregistrer -->
                <div class="col-sm-12 text-right mt-3">
                    <button type="submit" class="btn btn-outline-success">Enregistrer</button>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>



<!-- Menu with Checkboxes -->
<mat-menu #menu="matMenu">
    <div class="scrollable-menu shadow-lg bg-body">
        <mat-checkbox [checked]="displayedColumns.length == columns.length" (change)=" handleIsAllColsSelected($event)"
                      (click)="$event.stopPropagation()">Tous
        </mat-checkbox>
        @for (col of columns; track $index) {
            <div>
                <mat-checkbox [value]="col"
                              [checked]="displayedColumns.includes(col) || displayedColumns.length == columns.length"
                              (click)="$event.stopPropagation(); onSelectionChange(col)">
                    {{ columnLabels[col] || col }}
                </mat-checkbox>
            </div>
        }
    </div>

</mat-menu>
